const updateOptionsWithValue =
  (optionId, optionValue) => (previousSelectedOptions) => {
    if (optionValue != null) {
      return {
        ...previousSelectedOptions,
        [optionId]: optionValue,
      };
    }

    return Object.keys(previousSelectedOptions)
      .filter((key) => key !== optionId)
      .reduce(
        (selectedOptions, key) => ({
          ...selectedOptions,
          [key]: previousSelectedOptions[key],
        }),
        {}
      );
  };

export default updateOptionsWithValue;
